import { Box, Link, ScopedCssBaseline, ThemeProvider, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { Route, Switch, Link as RouterLink, useLocation } from 'react-router-dom'
import { usePageConfig } from 'src/hooks/usePageConfig'
import logo from 'src/assets/new-landing/cl_logo.webp'
import tagline from 'src/assets/new-landing/cl_tagline_red.svg'
import tradeArrow from 'src/assets/new-landing/cl_trade_arrow_grey.svg'
import { Footer } from './Footer'
import { HelperProvider, useHelper } from './HelperContext'
import { ForgotPasswordPage } from './forgot-password'
import { UpdatePasswordPage } from './update-password'
import { LoginPage } from './login'
import { nestedTheme } from './NestedTheme'

import { WhitelabelLogin } from './WhitelabelLogin'
import WLForgotPassword from 'src/views/password/ForgotPassword'
import WLUpdatePassword from 'src/views/password/UpdatePasswordForm'

const AuthLayoutInner = () => {
  const { styles } = useHelper()
  const theme = useTheme()
  const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'))
  const location = useLocation()

  const getTitle = () => {
    if (location.pathname.includes('/forgot')) return 'Forgot Password'
    if (location.pathname.includes('/update-password')) return 'Update Password'
    return 'Login'
  }

  usePageConfig({ title: getTitle() + ' | Next Generation Trade Platform', viewportScale: 1 })

  return <>
    <Box className={styles.Background} display={isBelowSm ? 'none' : 'block'}>
      <Box className={`${styles.TradeArrow} ${styles.desktop}`}>
        <img src={tradeArrow} alt="CrimsonLogic Trade Arrow" />
      </Box>
      <div className={styles.set}>
        <div className={`${styles.Tagline} ${styles.desktop}`}>
          <img src={tagline} alt="Simpler trade. Smarter tech." />
        </div>
      </div>
    </Box>
    <Box className={`${styles.Panel}`}>
      <Box className={styles.Box}>
        <Box component='header' className={styles.Header}>
          <Link component={RouterLink} to="/">
            <Box className={styles.Logo}>
              <img src={logo} alt="CrimsonLogic Logo" />
            </Box>
          </Link>
          <Typography variant='h1' id="productName" textAlign='start'>Next Generation Trade Platform</Typography>
        </Box>

        <Box className={styles.Form}>
          <Switch>
            <Route path="/forgot" component={ForgotPasswordPage} />
            <Route path="/update-password" component={UpdatePasswordPage} />
            <Route path="/login" component={LoginPage} />
          </Switch>
        </Box>

        <Footer />
      </Box>

    </Box>
  </>
}

export const AuthLayout = () => {
  let homePagePath = sessionStorage.getItem("homePagePath")
  const location = useLocation()

  if (homePagePath) {
    if (location.pathname === '/login')
      return <WhitelabelLogin homePagePath={homePagePath || '/'} />
    if (location.pathname === '/forgot')
      return <WLForgotPassword />
    if (location.pathname === '/update-password')
      return <WLUpdatePassword />
  }


  return <ThemeProvider theme={nestedTheme}>
    <ScopedCssBaseline>
      <HelperProvider>
        <AuthLayoutInner />
      </HelperProvider>
    </ScopedCssBaseline>
  </ThemeProvider>
}
